import { core } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

interface State {
  isInitialized: boolean;
  roles: core.AssignedPatronRole[];
}

const initialState: State = {
  isInitialized: false,
  roles: [],
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.PARTNER_ROLE_FETCH_ALL_DONE:
      return {
        ...state,
        roles: payload,
        isInitialized: true,
      };
    case AppConstants.PARTNER_ROLE_FETCH_ALL_STARTING:
      return {
        ...state,
        isInitialized: false,
      };
    case AppConstants.PARTNER_ROLE_FETCH_ALL_FAILED:
      return {
        ...state,
        isInitialized: true,
      };
    default:
      return state;
  }
}
